import consumerApi from "@/api/services/consumer-api";
import { ArrayDataEnvelope } from "@/api/types";
import { DispensaryPhoto } from "@/custom-types/Dispensary";

export async function getDispensaryPhotos(
  slug: string,
  take: number,
  skip: number,
): Promise<ArrayDataEnvelope<DispensaryPhoto>> {
  const { data } = await consumerApi.get(
    `/api/dispensaries/v1/${slug}/photos`,
    { params: { skip, take } },
  );
  return data;
}
